(function () {
  "use strict";

  var t = {
    960: function _(t, e, r) {
      var _n,
          o = this && this.__extends || (_n = function n(t, e) {
        return (_n = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (t, e) {
          t.__proto__ = e;
        } || function (t, e) {
          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
          }
        })(t, e);
      }, function (t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");

        function r() {
          this.constructor = t;
        }

        _n(t, e), t.prototype = null === e ? Object.create(e) : (r.prototype = e.prototype, new r());
      }),
          s = this && this.__awaiter || function (t, e, r, n) {
        return new (r || (r = Promise))(function (o, s) {
          function i(t) {
            try {
              u(n.next(t));
            } catch (t) {
              s(t);
            }
          }

          function a(t) {
            try {
              u(n.throw(t));
            } catch (t) {
              s(t);
            }
          }

          function u(t) {
            var e;
            t.done ? o(t.value) : (e = t.value, e instanceof r ? e : new r(function (t) {
              t(e);
            })).then(i, a);
          }

          u((n = n.apply(t, e || [])).next());
        });
      },
          i = this && this.__generator || function (t, e) {
        var r,
            n,
            o,
            s,
            i = {
          label: 0,
          sent: function sent() {
            if (1 & o[0]) throw o[1];
            return o[1];
          },
          trys: [],
          ops: []
        };
        return s = {
          next: a(0),
          throw: a(1),
          return: a(2)
        }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
          return this;
        }), s;

        function a(s) {
          return function (a) {
            return function (s) {
              if (r) throw new TypeError("Generator is already executing.");

              for (; i;) {
                try {
                  if (r = 1, n && (o = 2 & s[0] ? n.return : s[0] ? n.throw || ((o = n.return) && o.call(n), 0) : n.next) && !(o = o.call(n, s[1])).done) return o;

                  switch (n = 0, o && (s = [2 & s[0], o.value]), s[0]) {
                    case 0:
                    case 1:
                      o = s;
                      break;

                    case 4:
                      return i.label++, {
                        value: s[1],
                        done: !1
                      };

                    case 5:
                      i.label++, n = s[1], s = [0];
                      continue;

                    case 7:
                      s = i.ops.pop(), i.trys.pop();
                      continue;

                    default:
                      if (!((o = (o = i.trys).length > 0 && o[o.length - 1]) || 6 !== s[0] && 2 !== s[0])) {
                        i = 0;
                        continue;
                      }

                      if (3 === s[0] && (!o || s[1] > o[0] && s[1] < o[3])) {
                        i.label = s[1];
                        break;
                      }

                      if (6 === s[0] && i.label < o[1]) {
                        i.label = o[1], o = s;
                        break;
                      }

                      if (o && i.label < o[2]) {
                        i.label = o[2], i.ops.push(s);
                        break;
                      }

                      o[2] && i.ops.pop(), i.trys.pop();
                      continue;
                  }

                  s = e.call(t, i);
                } catch (t) {
                  s = [6, t], n = 0;
                } finally {
                  r = o = 0;
                }
              }

              if (5 & s[0]) throw s[1];
              return {
                value: s[0] ? s[1] : void 0,
                done: !0
              };
            }([s, a]);
          };
        }
      },
          a = this && this.__rest || function (t, e) {
        var r = {};

        for (var n in t) {
          Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (r[n] = t[n]);
        }

        if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;

          for (n = Object.getOwnPropertySymbols(t); o < n.length; o++) {
            e.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[o]) && (r[n[o]] = t[n[o]]);
          }
        }

        return r;
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      });

      var u = r(709),
          c = r(754),
          l = r(463),
          p = r(929).Debug("ledger"),
          f = function (t) {
        function e(e) {
          var r = t.call(this, {
            network: e.network
          }) || this;
          return r._App = e.App, r._Transport = e.Transport, r._network = e.network, r._ledgerScrambleKey = e.ledgerScrambleKey, r;
        }

        return o(e, t), e.prototype.createTransport = function () {
          return s(this, void 0, void 0, function () {
            var t,
                e = this;
            return i(this, function (r) {
              switch (r.label) {
                case 0:
                  return this._transport ? [3, 2] : (p("creating ledger transport"), t = this, [4, this._Transport.create()]);

                case 1:
                  t._transport = r.sent(), p("ledger transport created"), this._transport.on("disconnect", function () {
                    p("ledger disconnected"), e._appInstance = null, e._transport = null;
                  }), r.label = 2;

                case 2:
                  return [2];
              }
            });
          });
        }, e.prototype.errorProxy = function (t, e) {
          var r = this,
              n = t[e];
          return Object.getOwnPropertyNames(t).includes(e) && "function" == typeof n ? function () {
            for (var o = [], u = 0; u < arguments.length; u++) {
              o[u] = arguments[u];
            }

            return s(r, void 0, void 0, function () {
              var r, s, u;
              return i(this, function (i) {
                switch (i.label) {
                  case 0:
                    p('calling "' + e + '" on ledger object', o), i.label = 1;

                  case 1:
                    return i.trys.push([1, 3,, 4]), [4, n.bind(t).apply(void 0, o)];

                  case 2:
                    return r = i.sent(), p('result from "' + e + '" on ledger object', r), [2, r];

                  case 3:
                    throw (s = i.sent()).name, u = a(s, ["name"]), this._transport = null, this._appInstance = null, new c.WalletError(s.toString(), u);

                  case 4:
                    return [2];
                }
              });
            });
          } : n;
        }, e.prototype.getApp = function () {
          return s(this, void 0, void 0, function () {
            var t, e;
            return i(this, function (r) {
              switch (r.label) {
                case 0:
                  return r.trys.push([0, 2,, 3]), [4, this.createTransport()];

                case 1:
                  return r.sent(), [3, 3];

                case 2:
                  throw (t = r.sent()).name, e = a(t, ["name"]), new c.WalletError(t.toString(), e);

                case 3:
                  return this._appInstance || (this._appInstance = new Proxy(new this._App(this._transport), {
                    get: this.errorProxy.bind(this)
                  })), [2, this._appInstance];
              }
            });
          });
        }, e.prototype.isWalletAvailable = function () {
          return s(this, void 0, void 0, function () {
            var t, e;
            return i(this, function (r) {
              switch (r.label) {
                case 0:
                  return [4, this.getApp()];

                case 1:
                  (t = r.sent()).transport.scrambleKey || t.transport.setScrambleKey(this._ledgerScrambleKey), e = t.transport.exchangeTimeout, t.transport.setExchangeTimeout(2e3), r.label = 2;

                case 2:
                  return r.trys.push([2, 4, 5, 6]), [4, this._transport.send(224, 192, 0, 0)];

                case 3:
                  return r.sent(), [3, 6];

                case 4:
                  return r.sent(), [2, !1];

                case 5:
                  return t.transport.setExchangeTimeout(e), [7];

                case 6:
                  return [2, !0];
              }
            });
          });
        }, e.prototype.getConnectedNetwork = function () {
          return s(this, void 0, void 0, function () {
            return i(this, function (t) {
              return [2, this._network];
            });
          });
        }, e.prototype.getWalletAddress = function (t) {
          return s(this, void 0, void 0, function () {
            var e, r, n, o, s, a;
            return i(this, function (i) {
              switch (i.label) {
                case 0:
                  e = 0, r = !1, n = 5e3, o = 50, i.label = 1;

                case 1:
                  return e < n ? [4, this.getAddresses(e, o, r)] : [3, 3];

                case 2:
                  return s = i.sent(), (a = s.find(function (e) {
                    return l.caseInsensitiveEqual(e.address, t);
                  })) ? [2, a] : ((e += o) === n && !1 === r && (e = 0, r = !0), [3, 1]);

                case 3:
                  throw new Error("Ledger: Wallet does not contain address");
              }
            });
          });
        }, e;
      }(u.WalletProvider);

      e.default = f;
    },
    175: function _(t, e, r) {
      var n = this && this.__importDefault || function (t) {
        return t && t.__esModule ? t : {
          default: t
        };
      };

      Object.defineProperty(e, "__esModule", {
        value: !0
      }), e.LedgerProvider = void 0;
      var o = n(r(960));
      e.LedgerProvider = o.default;
    },
    929: function _(t) {
      t.exports = require("@liquality/debug");
    },
    754: function _(t) {
      t.exports = require("@liquality/errors");
    },
    463: function _(t) {
      t.exports = require("@liquality/utils");
    },
    709: function _(t) {
      t.exports = require("@liquality/wallet-provider");
    }
  },
      e = {},
      r = function r(n) {
    var o = e[n];
    if (void 0 !== o) return o.exports;
    var s = e[n] = {
      exports: {}
    };
    return t[n].call(s.exports, s, s.exports, r), s.exports;
  }(175);

  module.exports = r;
})();